import React from 'react';
import { Button } from '../../../../../../base/components/Button';
import { PhoneInput } from '../../../../../../base/components/Forms/PhoneInput';
import { Icon } from '../../../../../../base/components/Icon';
import { useAppDispatch, useAppSelector, useRoutesWithLang } from '../../../../../../base/hooks';
import { __t } from '../../../../../../base/utils/t';
import { passwordRecoveryActions } from '../../../redux/slices/passwordRecoverySlice';
import { AuthRoutes as RecruiterAuthRoutes } from '../../../../../../recruiter/units/authorization/routes';

import '../styles.scss';

export const VerificationMethod = () => {
    const dispatch = useAppDispatch();
    const { phoneInputConfig } = useAppSelector((state) => state.workerApp.config);
    const {
        fields: { phone },
        errors,
    } = useAppSelector((state) => state.workerAppPasswordRecovery);
    const recruiterAuthRoutes = useRoutesWithLang<typeof RecruiterAuthRoutes>(RecruiterAuthRoutes);

    const inputChangeHandler = (id: string, value: unknown) => {
        dispatch(passwordRecoveryActions.setField({ id, value }));
    };

    const recoverPasswordSubmitHandler = () => dispatch(passwordRecoveryActions.submitRecoverPassword());

    return (
        <div className='password-recovery'>
            <p className='password-recovery__title'>
                {__t('Для подтверждения мы вышлем на ваш номер мобильного телефона SMS/Viber с кодом.')}
            </p>
            <div className='worker-signup__form-item scroll-margin-for-fixed-header'>
                <p className='worker-signup__form-label'>{__t('Номер телефона, на который вы регистрировались')}</p>
                <PhoneInput
                    value={phone}
                    onChange={(value: string) => inputChangeHandler('phone', value)}
                    errors={errors?.phone}
                    onlyCountries={phoneInputConfig.countries}
                    preferredCountries={phoneInputConfig.preferredCountries}
                    localization={phoneInputConfig.localization}
                />
            </div>
            <Button className='password-recovery__button' onClick={recoverPasswordSubmitHandler}>
                {__t('Отправить')}
            </Button>
            <a
                href={`${window.GLOBALS?.crossSiteBaseUrl}${recruiterAuthRoutes.PasswordRecovery}`}
                className='password-recovery__recruiters-link'
            >
                <Icon
                    icon='user-tie-hair-solid'
                    color='highlight'
                    className='password-recovery__recruiters-link-icon'
                />
                {__t('Я рекрутер')}
            </a>
        </div>
    );
};
